import logo from "../assets/images/logo_white.png";
import { HashLink } from "react-router-hash-link";
import SocialLinks from "./SocialLinks";
import { useState } from "react";

function NavigationBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const showMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className={"navigation-bar" + (mobileMenuOpen ? " menu-open" : "")}>
      <div className="navigation-bar-container">
        <div className="row" id="navigation-bar-items">
          <div
            className="col-md-4 justify-content-start order-md-1 order-2"
            id="navigation-bar-pages"
            style={{ margin: "auto 0px", display: "flex" }}
          >
            <p>
              <HashLink to="/#tours" className="page-section-link">
                Tour
              </HashLink>
            </p>
            <p>
              <HashLink to="/#contact-us" className="page-section-link">
                Contact
              </HashLink>
            </p>
          </div>
          <div
            className="col-md-4 row align-items-center justify-content-center order-md-2 order-1"
            style={{ marginLeft: "15px" }}
            id="navigation-bar-logo"
          >
            <a href="/">
              <img
                alt="boneheads logo"
                src={logo}
                style={{
                  height: "75px",
                }}
              />
            </a>
            {mobileMenuOpen ? (
              <i
                className="fa-solid fa-xmark"
                id="hamburger-menu"
                style={{ fontSize: "30px" }}
                onClick={showMobileMenu}
              ></i>
            ) : (
              <i
                className="fa-solid fa-bars"
                id="hamburger-menu"
                style={{ fontSize: "25px" }}
                onClick={showMobileMenu}
              ></i>
            )}
          </div>
          <div
            className="col-md-4 justify-content-end order-md-3 order-3"
            id="navigation-bar-links"
            style={{ margin: "auto 0px", display: "flex" }}
          >
            <SocialLinks type="nav" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavigationBar;
